import React, { HTMLAttributes } from 'react';
import styled, { CSSObject } from '@emotion/styled';

export interface DivSXProps
  extends Omit<HTMLAttributes<HTMLDivElement>, 'style'> {
  sx?: CSSObject;
}

const StyledDiv = styled.div((prev: DivSXProps) => prev.sx);

/** 如果要用sx就使用這個div */
const DivSX = (props: DivSXProps) => <StyledDiv {...props} />;

export default DivSX;
